import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VOverlay,{attrs:{"value":_vm.progress,"color":"primary"}},[_c(VProgressCircular,{attrs:{"indeterminate":"","size":"64","color":"accent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }